import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactComponent as Error } from '../../Assets/error-icon.svg';
import { ReactComponent as Info } from '../../Assets/info.svg';
import { ReactComponent as Success } from '../../Assets/success-checkmark.svg';
import Text from '../Text';

const defaultToastParams = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  closeButton: false,
};

const icons = {
  success: <Success className='success-icon' />,
  error: <Error className='error-icon' />,
  info: <Info className='info-icon' />,
};

const MessageBox = ({ message, type }) => (
  <div className='toast-box'>
    <Text size='SM'>{message}</Text>
    {icons[type]}
  </div>
);

const notify = {
  success: (message, params = {}) =>
    toast(<MessageBox message={message} type='success' />, {
      ...defaultToastParams,
      ...params,
    }),

  error: (message, params) =>
    toast(<MessageBox message={message} type='error' />, {
      ...defaultToastParams,
      ...params,
    }),

  info: (message, params) =>
    toast(<MessageBox message={message} type='info' />, {
      ...defaultToastParams,
      ...params,
    }),
};

export default notify;
